import * as React from "react";

import PiezoSonicIcon from "../../assets/piezo_sonic.webp";
import MujuryokuIcon from "../../assets/mujuryoku.png";
import SuzukiIcon from "../../assets/suzuki.png";
import StreamIcon from "../../assets/stream.png";

const PARTNERS = [
  { href: "https://mujyuryoku.co/", src: MujuryokuIcon, alt: "無重力" },
  { href: "https://www.facebook.com/suzukitokei.toyota/", src: SuzukiIcon, alt: "スズキ時計店" },
  { href: "https://stream.gakuseiguild.co.jp/", src: StreamIcon, alt: "Stream" },
];

function Partners() {
  return (
    <section className="trps-section trps-dark2" id="Partners">
      <div className="trps-wrap">
        <h2 className="trps-h">パートナー</h2>
        <p className="trps-sub">
          世界に挑むTRAPSの活動は、パートナーの皆さまに支えられています。
        </p>

        <div className="trps-partner-hero">
          <div className="trps-partner-hero__logo">
            <a href="https://piezo-sonic.com/" target="_blank" rel="noopener noreferrer">
              <img src={PiezoSonicIcon} alt="Piezo Sonic" />
            </a>
          </div>
          <p className="trps-sub" style={{ marginTop: 0, maxWidth: "70ch", marginLeft: "auto", marginRight: "auto" }}>
            株式会社Piezo Sonicは、モーターとロボットの開発・製造・販売を行う
            ハードウェア スタートアップ。超音波モーターの長寿命化を実現し、
            精密搬送やロボットの分野へ展開。3C（Cool・Cute・Compact）の設計思想から
            生まれた製品はグッドデザイン賞やCESイノベーションアワードを受賞しています。
          </p>
        </div>

        <div className="trps-partners-grid">
          {PARTNERS.map((partner) => (
            <a
              key={partner.alt}
              className="trps-partner-cell"
              href={partner.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={partner.src} alt={partner.alt} />
            </a>
          ))}
        </div>

        {/* <div className="trps-cta-box">
          <h3 className="trps-lead" style={{ marginBottom: 10 }}>パートナー募集中</h3>
          <p className="trps-sub" style={{ margin: "0 auto" }}>
            TRAPSの挑戦を応援してくださる個人・企業パートナー様を募集しています。
            ご関心をお持ちの方は、下記よりお気軽にお問い合わせください。
          </p>
        </div> */}
      </div>
    </section>
  );
}

export default Partners;
